import { createStore } from 'vuex'
import VueCookies from 'vue-cookies'
import { getViews, getAuthToken, getConfiguration, getSession, checkSession, clearSession, logWarning, logEvent, getUser, getInsights, getFilterList, submitSaveFilterParams, getPreviousFilterParams, submitSimulatorParams, getAggregatorList, GetFilterSet, submitUpdateFilterParams, fetchAscendMarketingFlag ,fetchATPFlag} from './actions'
import { updateViews, updateSummaryView, selectContent, setClickedViewId, updateConfiguration, updateVizLoaded, updateUser, updateInsights, getFilterListData, updateCookies, getAggregatorListData, getFilterSetList, setFeatureFlag,setATPFeatureFlag } from './mutations'
import { ViewCategory, ViewList} from './models'


const viewCategories = views => views.reduce((vl, x) => {
    if (!x.firstTag) {
        return vl
    }

    let cat = vl.getCategory(x.firstTag)

    if (cat) {
        cat.addView(x)
    }
    else {
        let c = new ViewCategory(x.firstTag)
        c.addView(x)
        vl.addCategory(c)
    }

    return vl
}, new ViewList())

export default createStore({
    state: {
        views: [],
        summaryView: null,
        configuration: null,
        selectedContent: null,
        clickedViewId: null,
        vizLoaded: false,
        user: null,
        insights: null,
        filterList: [],
        aggregatorList: [],
        cookiesExist: false,
        filterSetList: [],
        featureFlags: {
            atpliteheader: undefined,
            ascendMarketing: undefined
        }
    },
    mutations: {
        'UPDATE_VIEWS': updateViews,
        'UPDATE_SUMMARY_VIEW': updateSummaryView,
        'SELECT_CONTENT': selectContent,
        'SET_CLICKED_VIEW_ID': setClickedViewId,
        'SET_COOKIES': updateCookies,
        'UPDATE_CONFIGURATION': updateConfiguration,
        'UPDATE_VIZ_LOADED': updateVizLoaded,
        'UPDATE_USER': updateUser,
        'UPDATE_INSIGHTS': updateInsights,
        'GET_FILTERLIST': getFilterListData,
        'GET_AGGREGATOR_LIST': getAggregatorListData,
        'GET_FILTERSET_LIST': getFilterSetList,
        'SET_FEATURE_FLAG': setFeatureFlag,
        'SET_ATP_FEATURE_FLAG': setATPFeatureFlag

    },
    actions: {
        getViews,
        getAuthToken,
        getConfiguration,
        getSession,
        checkSession,
        clearSession,
        logWarning,
        logEvent,
        getUser,
        getInsights,
        getFilterList,
        submitSaveFilterParams,
        getPreviousFilterParams,
        submitSimulatorParams,
        getAggregatorList,
        GetFilterSet,
        submitUpdateFilterParams,
        fetchAscendMarketingFlag,
        fetchATPFlag
    },
    getters: {
        selectedContent: state => state.selectedContent,
        clickedViewId: state => state.clickedViewId,
        views: state => state.views,
        viewsByCategory: state => viewCategories(state.views),
        summaryView: state => state.summaryView,
        configuration: state => state.configuration,
        vizLoaded: state => state.vizLoaded,
        user: state => state.user,
        insights: state => state.insights,
        filterList: state => state.filterList.filter(a => a.name != "aggregator_brand-MultiSelect"),
        aggregatorList: state => state.aggregatorList,
        cookieConsent: () => VueCookies.isKey("cookies_consent"),
        filterSetList: state => state.filterSetList,
        ascendMarketingEnabled: state => state.featureFlags.ascendMarketing,
        // Return the actual value (undefined, true, or false) so we can detect if it's loaded
        atpLiteHeaderEnabled: state => state.featureFlags.atpliteheader,
        //unreadInsightsNumber: state => state.insights.filter(i => !i.read).length
    }
})
